import http from "./httpService";

const apiEndPoint = "/locations/";

function getServerIpUrl(serverName) {
  return `${apiEndPoint}get_vpn_ip/${encodeURIComponent(serverName)}`;
}

function getServerStatusUrl(serverName) {
  return `/machine/status/${serverName}/`;
}

export function getServerIp(serverName, config = {}) {
  return http.get(getServerIpUrl(serverName), config);
}

export function getServerStatus(serverName) {
  // Get the server status from the manager-api
  return http.get(getServerStatusUrl(serverName));
}
